import { API_DOMAIN, notificationStrings } from '@constants/app-constants';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import React, { useEffect, useState } from 'react';

import Actions from '../action';
import { useHistory, useLocation } from 'react-router-dom';
import ContactInfoPresentational from './contactinfoPresentational';
import Selectors from '../selectors';
import { connect } from 'react-redux';
import { openNotificationWithIcon } from '@sharedComponent/notification-message/notification';

const ContactInfoFunctional = ({ allowNavigate, navigateDisabled, buttonMode, buttonName }) => {
	const [contactObj, setContacts] = useState({ contacts: [], payrollObjProp: {}, hrObjProp: {}, additionalContacts: [] });
	const [savingData, setSavingData] = useState(false);
	useEffect(() => {
		allowNavigate?.(1);
		buttonMode?.('single');
		buttonName?.('Next');
	}, []);

	const history = useHistory();

	const companyId = localStorage.getItem('companyId');
	useEffect(() => {
		// const companyId = localStorage.getItem('companyId');
		axios
			.get(`${API_DOMAIN}/Contact/${companyId}`)
			.then((res) => {
				const contacts = res?.data?.contacts;
				let payrollObjProp = Object.assign({}, ...contacts.filter((data) => data.contactType === 'MainPayroll'));
				let hrObjProp = Object.assign({}, ...contacts.filter((data) => data.contactType === 'MainHR'));
				let additionalContacts = contacts.filter((data) => data.contactType === 'Additional');
				additionalContacts = additionalContacts.map((data) => {
					return {
						...data,
						index: uuidv4(),
						hrNameProp: data?.name,
						hrMobileProp: data?.mobile,
						hrLandlineProp: data?.landLine,
						hrEmailProp: data?.email,
					};
				});
				payrollObjProp = {
					...payrollObjProp,
					payrollName: payrollObjProp?.name,
					payrollMobile: payrollObjProp?.mobile,
					payrollLandline: payrollObjProp?.landLine,
					payrollEmail: payrollObjProp?.email,
				};
				hrObjProp = {
					...hrObjProp,
					hrName: hrObjProp?.name,
					hrMobile: hrObjProp?.mobile,
					hrLandline: hrObjProp?.landLine,
					hrEmail: hrObjProp?.email,
				};

				setContacts({ contacts: res?.data?.contacts, payrollObjProp, hrObjProp, additionalContacts });
			})
			.catch((err) => {
				console.log('companyId', err);
			});
	}, []);

	const handleSubmit = (payrollObj, hrProj, additionalContacts = []) => {
		setSavingData(true);
		additionalContacts = additionalContacts.map((data) => {
			return {
				contactId: data?.contactId || null,
				name: data?.hrNameProp || null,
				mobile: data?.hrMobileProp || null,
				landLine: data?.hrLandlineProp || null,
				email: data?.hrEmailProp || null,
				contactType: data?.contactType || null,
			};
		});
		const contactList = [
			{
				contactId: payrollObj?.contactId || null,
				name: payrollObj?.payrollName || null,
				mobile: payrollObj?.payrollMobile || null,
				landLine: payrollObj?.payrollLandline || null,
				email: payrollObj?.payrollEmail || null,
				contactType: payrollObj?.contactType || 'MainPayroll',
			},
			{
				contactId: hrProj?.contactId || null,
				name: hrProj?.hrName || null,
				mobile: hrProj?.hrMobile || null,
				landLine: hrProj?.hrLandline || null,
				email: hrProj?.hrEmail || null,
				contactType: hrProj?.contactType || 'MainHR',
			},
			...additionalContacts,
		];
		console.log('PAYLOAD ::', contactList);
		axios
			.patch(`${API_DOMAIN}/Contact/${companyId}/update`, {
				contactList,
			})
			.then(() => {
				setSavingData(false);
				openNotificationWithIcon(notificationStrings.success, 'Contact Info Saved Successfully.');
				// history.push('/user/contactinfo/2');
				history.push({
					pathname: `/user/contactinfo/2`,
					state: {
						companyId: companyId,
					},
				});
			})
			.catch(() => {
				setSavingData(false);
			});
	};

	const { payrollObjProp, contacts, hrObjProp, additionalContacts } = contactObj;

	return (
		<ContactInfoPresentational
			navigateDisabled={navigateDisabled}
			{...{ contacts, payrollObjProp, hrObjProp, additionalContacts, handleSubmit, savingData }}
		/>
	);
};
const mapStateToProps = (state) => {
	return {
		contactInfoData: Selectors.contactInfoData(state),
		isContactLoading: Selectors.isContactLoading(state),
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		getContactInfoStart: () => dispatch(Actions.creators.getContactInfoStart()),
	};
};

const Connected = connect(mapStateToProps, mapDispatchToProps)(ContactInfoFunctional);
export default Connected;
